module.exports = __webpack_public_path__ + "assets/img/ic-filter-hover.ff6b426a.svg";